import styles from "./agentStatus.module.scss";
import AgentEmpty from "../../../../styles/images/agentempty.svg";


function AgentStatusEmpty() {
  return (
    <>
      <div className={`${styles.listSecempty} ${styles.datalistagent}`}>
        <img src={AgentEmpty} alt="pdf" />
        <h5>No data found</h5>
      </div>

    </>
  );
}

export default AgentStatusEmpty;
